// Utilidades de máscara e validação para CPF/CNPJ

export function digitsOnly(value = '') {
  return (value || '').toString().replace(/\D+/g, '');
}

export function cleanCpfCnpj(value = '') {
  return (value || '')
    .toString()
    .replace(/[^\dA-Za-z]/g, '')
    .toUpperCase();
}

export function formatCpf(value = '') {
  const v = digitsOnly(value).slice(0, 11);
  if (v.length <= 3) return v;
  if (v.length <= 6) return `${v.slice(0, 3)}.${v.slice(3)}`;
  if (v.length <= 9) return `${v.slice(0, 3)}.${v.slice(3, 6)}.${v.slice(6)}`;
  return `${v.slice(0, 3)}.${v.slice(3, 6)}.${v.slice(6, 9)}-${v.slice(9, 11)}`;
}

export function formatCnpj(value = '') {
  const v = cleanCpfCnpj(value).slice(0, 14);
  if (v.length <= 2) return v;
  if (v.length <= 5) return `${v.slice(0, 2)}.${v.slice(2)}`;
  if (v.length <= 8) return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5)}`;
  if (v.length <= 12) return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8)}`;
  return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8, 12)}-${v.slice(12, 14)}`;
}

export function formatCpfCnpj(value = '') {
  const d = cleanCpfCnpj(value);
  if (d.length <= 11 && /^\d+$/.test(d)) return formatCpf(d);
  return formatCnpj(d);
}

export function isValidCpf(value = '') {
  const digits = digitsOnly(value);
  if (digits.length !== 11) return false;
  if (/^(\d)\1+$/.test(digits)) return false;

  let sum = 0;
  for (let index = 0; index < 9; index += 1) {
    sum += Number(digits[index]) * (10 - index);
  }

  let remainder = (sum * 10) % 11;
  if (remainder === 10) remainder = 0;
  if (remainder !== Number(digits[9])) return false;

  sum = 0;
  for (let index = 0; index < 10; index += 1) {
    sum += Number(digits[index]) * (11 - index);
  }

  remainder = (sum * 10) % 11;
  if (remainder === 10) remainder = 0;
  return remainder === Number(digits[10]);
}

export function maskCnpjForDisplay(value) {
  if (!value) return '';
  const d = cleanCpfCnpj(value);
  if (d.length !== 14) return value; // mantem como veio
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
}

export function isValidCpfCnpj(value = '') {
  const d = cleanCpfCnpj(value);
  if (/^\d+$/.test(d) && d.length === 11) return isValidCpf(d);
  return d.length === 14; // mantem a validação atual de CNPJ por tamanho
}
